import { render, staticRenderFns } from "./HeaderVariant1.vue?vue&type=template&id=26c0feca&scoped=true&"
import script from "./HeaderVariant1.vue?vue&type=script&lang=js&"
export * from "./HeaderVariant1.vue?vue&type=script&lang=js&"
import style0 from "./HeaderVariant1.vue?vue&type=style&index=0&id=26c0feca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c0feca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VSpacer,VToolbar})
